// Thank You and Goodbye screen (static)
// NOTE: No redirects – customer closes the tab manually.
import React from 'react';
import { useLocation } from 'react-router-dom';

const ThankYouGoodbyeScreen: React.FC = () => {
  const location = useLocation();
  const { restaurantName, restaurantLogo } = location.state || {};

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4">
      {/* Restaurant Logo */}
      {restaurantLogo ? (
        <div className="w-24 h-24 rounded-full overflow-hidden mb-8 border-2 border-gray-200">
          <img src={restaurantLogo} alt="Logo" className="w-full h-full object-cover" />
        </div>
      ) : (
        <div className="w-24 h-24 rounded-full bg-gray-200 mb-8 flex items-center justify-center">
          <span className="text-3xl font-bold text-gray-400">
            {restaurantName?.charAt(0) || 'R'}
          </span>
        </div>
      )}

      {/* Message */}
      <h1 className="text-3xl font-bold text-gray-900 mb-4 text-center">
        Gracias por tu visita
      </h1>
      <p className="text-lg text-gray-600 text-center max-w-md">
        Siéntete libre de salir y no dudes en decir adiós
      </p>

      <p className="mt-8 text-xs text-gray-400">
        Puedes cerrar esta pestaña cuando quieras.
      </p>
    </div>
  );
};

export default ThankYouGoodbyeScreen;
